import {UserDetails} from "../actions/api";

export const getName = (userDetails: UserDetails): string =>  {
    if (userDetails.firstName !== undefined && userDetails.firstName !== '' && userDetails.lastName !== undefined && userDetails.lastName !== '') {
        return `${userDetails.firstName} ${userDetails.lastName}`
    }

    if (userDetails.firstName !== undefined && userDetails.firstName !== '' && (userDetails.lastName === undefined || userDetails.lastName === '')) {
        return userDetails.firstName
    }

    if (userDetails.lastName !== undefined && userDetails.lastName !== '' && (userDetails.firstName === undefined || userDetails.firstName === '')) {
        return userDetails.lastName
    }

    return ''
}